import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=3885502f&scoped=true"
import script from "./Complain.vue?vue&type=script&lang=js"
export * from "./Complain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885502f",
  null
  
)

export default component.exports